import React from 'react';
import Icon from '../../Icon';
import s from './editStudent.module.css';

// The control that opens an edit drawer.
//
// MMS puts a pencil on every card header that has a drawer behind it, and on
// its student page that is every card: the profile, the Student Details tab,
// Lesson Settings, Notes, and each family contact (#120). Nothing there is
// edited inline or on a separate page.
//
// It is a bare glyph on screen, so the accessible name has to be written: a
// button whose only content is an `aria-hidden` svg is announced as "button"
// and nothing else. `label` is what a screen reader says and what a test finds
// it by — "Edit Student Details" rather than five buttons all called "Edit".
export default function EditPencil({ label, onClick }) {
  return (
    <button type="button" className={s.pencil} aria-label={label} title={label} onClick={onClick}>
      <Icon name="pencil" size={15} />
    </button>
  );
}
